const reducer = (state, action) => {
  const { type, payload } = action;
  if (type == 'SORT_BY_CHANGED') {
    return { ...state, sortBy: payload };
  }
  return { ...state };
};

export default reducer;
